import type { TextAdvanceOption } from '@lighthouse/core'

/** 应用线上分支id */
export const APPLICATION_VERSION_PROD = 'PROD'

export const APPLICATION_ENV_PROD = 'PROD'

export const DEFAULT_DESKTOP_BREAK_POINT = 'desktop'

export const DEFAULT_MOBILE_BREAK_POINT = 'mobile'

/** 默认字体 */
export const TEXT_FONT_NORMAL = 'NORMAL'
/** 文本模板配置 */
export const TEXT_TEMPLATE_LIST: Omit<TextAdvanceOption, 'id'>[] = [
    {
        name: '超大标题',
        fontFamily: TEXT_FONT_NORMAL,
        fontSize: {
            size: 3,
            unit: 'rem'
        },
        letterSpacing: 0,
        lineHeight: 1.5
    },
    {
        name: '大标题',
        fontFamily: TEXT_FONT_NORMAL,
        fontSize: {
            size: 2,
            unit: 'rem'
        },
        letterSpacing: 0,
        lineHeight: 1.5
    },
    {
        name: '中标题',
        fontFamily: TEXT_FONT_NORMAL,
        fontSize: {
            size: 1.5,
            unit: 'rem'
        },
        letterSpacing: 0,
        lineHeight: 1.45
    },
    {
        name: '小标题',
        fontFamily: TEXT_FONT_NORMAL,
        fontSize: {
            size: 1.25,
            unit: 'rem'
        },
        letterSpacing: 0,
        lineHeight: 1.5
    },
    {
        name: '正文',
        fontFamily: TEXT_FONT_NORMAL,
        fontSize: {
            size: 1,
            unit: 'rem'
        },
        letterSpacing: 0,
        lineHeight: 1.5
    }
]
